import { DollarSign, Send, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Label } from '../ui/label';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '../ui/dialog';

export const QuoteDialog = ({
  open, onOpenChange,
  quotePrice, setQuotePrice,
  quoteDeliveryDays, setQuoteDeliveryDays,
  quoteDescription, setQuoteDescription,
  quoteBuyerMessage, setQuoteBuyerMessage,
  sendingQuote, onSendQuote,
  recipientName,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-surface border-[#262626] max-w-md">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2"><DollarSign className="w-5 h-5 text-lime" />Send Custom Quote</DialogTitle>
        <DialogDescription>Create a custom order for {recipientName}</DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div>
          <Label htmlFor="quote-price">Price (USD)</Label>
          <div className="relative mt-1">
            <DollarSign className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#666]" />
            <Input id="quote-price" type="number" value={quotePrice} onChange={(e) => setQuotePrice(e.target.value)} className="input-dark pl-10" placeholder="0.00" min="1" step="0.01" data-testid="quote-price-input" />
          </div>
        </div>
        <div>
          <Label htmlFor="quote-delivery">Delivery Time (days)</Label>
          <Input id="quote-delivery" type="number" value={quoteDeliveryDays} onChange={(e) => setQuoteDeliveryDays(e.target.value)} className="input-dark mt-1" placeholder="7" min="1" max="45" data-testid="quote-delivery-input" />
        </div>
        <div>
          <Label htmlFor="quote-description">Description</Label>
          <Textarea id="quote-description" value={quoteDescription} onChange={(e) => setQuoteDescription(e.target.value)} className="input-dark mt-1" placeholder="Describe what you'll deliver..." rows={3} data-testid="quote-description-input" />
        </div>
        <div>
          <Label htmlFor="quote-buyer-message">Message to Buyer (optional)</Label>
          <Textarea id="quote-buyer-message" value={quoteBuyerMessage} onChange={(e) => setQuoteBuyerMessage(e.target.value)} className="input-dark mt-1" placeholder="Any special notes..." rows={2} data-testid="quote-buyer-message-input" />
        </div>
      </div>
      <DialogFooter>
        <Button variant="ghost" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onSendQuote} disabled={sendingQuote || !quotePrice || !quoteDescription.trim()} className="btn-primary" data-testid="submit-quote-btn">
          {sendingQuote ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Send className="w-4 h-4 mr-2" />}Send Quote
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
